import { useParams } from 'react-router';
import TechnicalContainer from '~/components/technical-session/container';

export default function TechnicalSession() {
  const { sessionId } = useParams<{ sessionId: string }>();

  return <TechnicalContainer sessionId={sessionId!} />;
}
